import { PartnerGroupRules } from 'src/graphql';

export type NotificationCategoryConfig = {
  displayName: string;
  icon: string;
  partnerGroupRules?: PartnerGroupRules[];
};

const notificationCategoryToConfig = new Map<string, NotificationCategoryConfig>([
  ['conversation', { displayName: 'conversations', icon: 'message-circle' }],
  ['signal', { displayName: 'Signal', icon: 'zap' }],
  ['crm', { displayName: 'CRM', icon: 'user' }],
  [
    'project',
    {
      displayName: 'Projects',
      icon: 'image',
      partnerGroupRules: [PartnerGroupRules.AccessToProvisionProjects],
    },
  ],
  [
    'subscription',
    {
      displayName: 'Subscriptions',
      icon: 'credit-card',
      partnerGroupRules: [PartnerGroupRules.AccessToSubscriptionManagement],
    },
  ],
]);

export const getCategoryConfig = (category: string): NotificationCategoryConfig => {
  return (
    notificationCategoryToConfig.get(category) ?? {
      displayName: category,
      icon: 'bell',
    }
  );
};

/**
 * @param categoryConfig The category config
 * @param partnerGroupRules The set of partner group rule values for the current user
 * @returns True if the user has access to one of the category's required partner group rules, false otherwise.
 */
export const shouldShowCategory = (
  categoryConfig: NotificationCategoryConfig,
  partnerGroupRules: Record<PartnerGroupRules, boolean>,
): boolean => {
  if (!categoryConfig.partnerGroupRules) {
    return true;
  }
  return categoryConfig.partnerGroupRules.some((rule) => partnerGroupRules[rule] === true);
};

export type NotificationChannelConfig = {
  icon: string;
};

export const notificationChannelToConfigMap = new Map<string, NotificationChannelConfig>([
  ['email', { icon: 'mail' }],
  ['in_app', { icon: 'bell' }],
  ['push', { icon: 'bell-ring' }],
]);
